export default "__VITE_ASSET__BduxoAw0__"